/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Tile_Email_TitleInputs */

const tr_landing_community_tile_email_title = /** @type {(inputs: Landing_Community_Tile_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta & Destek Talebi`)
};

const en_landing_community_tile_email_title = /** @type {(inputs: Landing_Community_Tile_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email & Support Tickets`)
};

const de_landing_community_tile_email_title = /** @type {(inputs: Landing_Community_Tile_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail & Support-Tickets`)
};

const ru_landing_community_tile_email_title = /** @type {(inputs: Landing_Community_Tile_Email_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Почта и тикеты`)
};

/**
* | output |
* | --- |
* | "Email & Support Tickets" |
*
* @param {Landing_Community_Tile_Email_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_tile_email_title = /** @type {((inputs?: Landing_Community_Tile_Email_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Tile_Email_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_tile_email_title(inputs)
	if (locale === "de") return de_landing_community_tile_email_title(inputs)
	if (locale === "ru") return ru_landing_community_tile_email_title(inputs)
	return tr_landing_community_tile_email_title(inputs)
});